import React from 'react';
import { Box } from '@fiverr-private/theme';
import type { EducationTooltipHeaderProps } from '../types';
import { useEducationTooltipContext } from '../EducationTooltipContext';

const EducationTooltipHeader = ({ children }: EducationTooltipHeaderProps) => {
  const { variant } = useEducationTooltipContext();

  return (
    <Box
      as="header"
      fontWeight="semibold"
      paddingBottom={variant === 'white' ? '1' : '4'}
      display="flex"
      alignItems="center"
      gap="2"
    >
      {children}
    </Box>
  );
};

EducationTooltipHeader.displayName = 'EducationTooltipHeader';

export default EducationTooltipHeader;
